import { api } from '@/core/api/request'
import { logger } from '@/core/app/logger'
import { QuestionnaireGetResponseSchema, QuestionnaireListResponseSchema } from '@/schemas/v2'
import type { QuestionnaireGetResponse, QuestionnaireListResponse } from '@/schemas/v2'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

export async function fetchQuestionnaires(options?: FetchOptions): Promise<QuestionnaireListResponse> {
  const url = `${BASE}/api/v2/questionnaires`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return QuestionnaireListResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function fetchQuestionnaire(id: number, options?: FetchOptions): Promise<QuestionnaireGetResponse> {
  const url = `${BASE}/api/v2/questionnaires/${id}`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return QuestionnaireGetResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function fetchQuestionnairesType(
  type: 'register' | 'reward',
  rewardId?: number,
  options?: FetchOptions,
): Promise<QuestionnaireGetResponse> {
  // rewardId は type=reward のときのみ有効。register に付けてもバックエンドは無視するが、
  // ログ・キャッシュの見通しのためフロント側でも送らない。
  // rewardId は number 型に限定されるため encodeURIComponent は不要。
  const query = type === 'reward' && rewardId != null ? `?rewardId=${rewardId}` : ''
  const url = `${BASE}/api/v2/questionnaires/type/${type}${query}`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return QuestionnaireGetResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function postQuestionnaireAnswer(
  id: number,
  body?: Record<string, unknown>,
  options?: FetchOptions,
): Promise<QuestionnaireGetResponse> {
  const url = `${BASE}/api/v2/questionnaires/${id}`
  logger.info({ fetch_method: 'POST', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.post<unknown>(url, body ?? {}, options)
    return QuestionnaireGetResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'POST', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}
